import { formatPlain } from './format.js';
import { fieldIndex } from './meta.js';
import { pluralizeUnit } from './plural.js';
const PLACEHOLDER = /\{([a-z][a-z0-9_]*)\}/g;
const EDGE_SEPARATORS = /^[\s—–:,-]+|[\s—–:,-]+$/g;
/** Коды полей, которые использует шаблон названия. */
export function titlePlaceholders(template) {
    return [...template.matchAll(PLACEHOLDER)].map((m) => m[1]);
}
/**
 * Название объекта по шаблону типа: '{denomination_value} {denomination_unit} {years} — {issuer}'.
 * Пустые подстановки и оставшиеся от них разделители убираются.
 */
export function renderTitle(meta, template, values, resolveRef) {
    const defs = fieldIndex(meta);
    const filled = template.replace(PLACEHOLDER, (_, code) => {
        const def = defs.get(code);
        if (!def)
            return '';
        const text = formatPlain(meta, def, values[code], resolveRef);
        // Единица номинала согласуется с числом из парного поля «…_value»: «10 рублей».
        if (def.refKind === 'currency_units' && code.endsWith('_unit') && text) {
            const amount = Number(values[code.replace(/_unit$/, '_value')]);
            if (Number.isFinite(amount))
                return pluralizeUnit(amount, text);
        }
        return text;
    });
    return filled
        .replace(/\(\s*\)/g, '')
        .replace(/(\s*[—–]\s*){2,}/g, ' — ')
        .replace(/\s+/g, ' ')
        .replace(EDGE_SEPARATORS, '')
        .trim();
}
//# sourceMappingURL=title.js.map